import { useSelector } from 'react-redux';
import { FlattenedUser } from '../types/user';

export default function useIsLoggedIn() {
	const user: FlattenedUser = useSelector( ( state: any ) => state.user );

	return !!user?.isLoggedIn;
}
